export default class Datas {
  constructor() {}
  validate() {}

  serialize() {
    let dataReturn = {}

    for (var i in this.data) {
      if (
        String(this.data[i].value) !== '' &&
        this.data[i].value !== undefined
      ) {
        dataReturn[this.data[i].fieldName] = this.data[i].value
      }
    }

    return dataReturn
  }

  onlyValue() {
    let dataReturn = {}

    for (var i in this.data) {
      if (!this.data[i].is_file) {
        dataReturn[i] = this.data[i].value
      }
    }

    return dataReturn
  }

  get(field) {
    if (!this.data[field]) {
      return false
    }

    return this.data[field].value
  }
  set(field, value) {
    if (!this.data[field]) {
      return false
    }

    this.data[field].value = value

    return true
  }
}
